import React, { useEffect, useState } from "react";
import { X, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "gai_popup_seen_v1";

export default function SmartPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 15000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
    try { localStorage.setItem(KEY, "1"); } catch { /* noop */ }
  };

  if (!open) return null;

  return (
    <div
      className="fixed bottom-6 left-6 z-[70] w-[360px] max-w-[92vw] shadow-2xl gai-fade-up"
      style={{
        background: "var(--gai-white)",
        border: "1px solid var(--gai-grey-200)",
        boxShadow: "0 30px 60px -20px rgba(0,0,0,0.25)",
      }}
      data-testid="smart-popup"
    >
      <div className="h-1 w-full" style={{ background: "var(--gai-red)" }} />
      <button
        onClick={close}
        className="absolute top-3 right-3 hover:opacity-70"
        style={{ color: "var(--gai-grey-500)" }}
        aria-label="Fermer"
        data-testid="smart-popup-close"
      >
        <X size={16} />
      </button>

      <div className="p-6">
        <div className="text-[0.62rem] font-bold tracking-[0.24em] uppercase mb-2" style={{ color: "var(--gai-red)" }}>
          Édition Hors-série · RDC
        </div>
        <h3 className="serif text-2xl leading-tight" style={{ color: "var(--gai-black)", fontFamily: "'Playfair Display', serif" }}>
          Feuilletez notre première édition.
        </h3>
        <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--gai-grey-700)" }}>
          Un dossier inédit sur la République Démocratique du Congo — éditorial, portraits, enjeux économiques et institutionnels.
        </p>

        <div className="mt-5 flex gap-2 flex-wrap">
          <Link
            to="/magazine"
            onClick={close}
            className="gai-btn-gold text-xs"
            data-testid="smart-popup-cta-read"
          >
            <ShoppingBag size={12} /> Découvrir — 19 €
          </Link>
          <Link
            to="/annoncer"
            onClick={close}
            className="gai-btn-ghost text-xs"
            data-testid="smart-popup-cta-ad"
          >
            Devenir annonceur →
          </Link>
        </div>
      </div>
    </div>
  );
}
